import { Button } from '@bennows/boows-react';
import { useTranslation } from 'react-i18next';
import { useSignOut } from './useSignOut';

/** Full page (spec 10 §6): the active tenant is no longer reachable; the only way out is signing out. */
export function TenantAccessDenied() {
  const { t } = useTranslation();
  const signOut = useSignOut();
  return (
    <main id="main" className="ui-auth" tabIndex={-1}>
      <section className="ui-card ui-auth__card ui-error-state" role="alert">
        <h1>{t('account.denied.title')}</h1>
        <p className="ui-error-state__text">
          {signOut.isError ? t('account.signOutFailed') : t('account.denied.text')}
        </p>
        <Button variant="primary" block loading={signOut.isPending} onClick={() => signOut.mutate()}>
          {t('account.signOut')}
        </Button>
      </section>
    </main>
  );
}
